/* eslint-disable max-len */
import React from "react";
// import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";
import { useRef ,useState} from "react";


export default function SearchMonitor({suggestions,selected,setSelected,setSuggestions,optimizedFn,searchParams,SearchPlaceholder,options,data,snakeToCamelCase,optionRef}){
    const ref = useRef(null);
    const [isOpen, setisOpen] = useState(false);
    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });
    
    return(
        <>
            <div  className=" flex justify-center relative ml-2.5 2xl:mb-0 mb-2.5">
                <label htmlFor="input"></label>
                <input
                    maxLength={90}
                    type="text"
                    id="search-value"
                    autoComplete='off'
                    value={suggestions}
                    autoFocus={suggestions !== ''}
                    onChange={(e) => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                    className="pl-10 pr-[31px] w-[222px] py-2.5 border border-[#972E4C] rounded-[16px] placeholder:text-xs placeholder:font-normal placeholder:text-[#52555D] text-base font-normal text-[#000B17] outline-0" placeholder={SearchPlaceholder} />
                <img src="/images/search_red.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 left-3" />
                <button onClick={() => { setSuggestions(""); optimizedFn("") }} className="">
                    {suggestions !== "" && <img src="/images/clear_search.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 right-[270px]" />}
                </button>
                <p className="text-sm mt-3 px-2 font-normal text-[#972E4C] ">in:</p>            
                <label htmlFor="input"></label>
                <button  id= "search-coloumn" onClick={() => setisOpen(!isOpen)} className={`pl-4 pr-4 w-[222px] py-2.5 border border-[#972E4C] rounded-[16px]  text-base font-normal 
                                 text-[#000B17]  outline-none bg-white flex justify-between items-center`} disabled={false}>
                    <p ref={optionRef} id= {"search-dropdown"}className={`text-[#000B17] text-start text-xs text-base font-normal `}>{searchParams?.get("search_column")?snakeToCamelCase(searchParams?.get("search_column")):selected}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen?"transform rotate-180" : ""}`}/>
                </button>
                <ul ref={ref} className={`p-4 rounded-lg bg-white z-[9] absolute top-[50px] w-[222px] left-[252px] border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} >
                    <li>
                        <ul className={` `}>
                            {
                                options?.map((option,i)=>(
                                    <li
                                        key={i}
                                        id={i}
                                        data-testid={option}
                                        onClick={(e) => {
                                            setSelected(option)
                                            setisOpen(false);
                                        }} 
                                    >
                                        <p className={` w-full inline-block cursor-pointer ${option===selected?`text-base text-[#008586]`:'text-sm font-normal text-[#000]'} hover:text-[#008586] ${options.length-1 === i ? '' : 'mb-5' }`}>{option}</p>
                                    </li>
                                ))
                            }
                        </ul>
                    </li>
                </ul>  
                
            </div>
                 
        </>
    )
}